import { Injectable } from '@angular/core';
import {BillingService} from "./billing.service";

export interface NavigationItem {
  title: string;
  routerLink?: string;
  icon: string;
  onClick?: () => void;
  layouts: string[];
  badge?: string;
  // 'bottom' items (Settings, Billing) are rendered as a separate group pinned
  // to the bottom of the sidebar, visually separated from the main items.
  section?: 'main' | 'bottom';
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(private billingService: BillingService) {}

  /**
   * Get all navigation items
   */
  getNavigationItems(): NavigationItem[] {
    return [
      // ----- Main layout -----
      // Order: Dashboard, My Reports, ICP, Workspace, Prospecting, Leads, CRM,
      // Exports, then Settings and Billing at the bottom.
      {
        title: 'Dashboard',
        routerLink: '/dashboard',
        icon: 'dashboard',
        layouts: ['main']
      },
      {
        title: 'My Reports',
        routerLink: '/reports',
        icon: 'reports',
        layouts: ['main']
      },
      {
        title: 'ICP Management',
        routerLink: '/icp',
        icon: 'icp',
        layouts: ['main']
      },
      {
        title: 'Workspaces',
        routerLink: '/workspaces',
        icon: 'workspaces',
        layouts: ['main']
      },
      {
        title: 'Prospecting',
        routerLink: '/advanced-search',
        icon: 'search',
        layouts: ['main']
      },
      {
        title: 'Leads',
        routerLink: '/leads',
        icon: 'leads',
        layouts: ['main']
      },
      {
        title: 'CRM',
        routerLink: '/crm',
        icon: 'crm',
        layouts: ['main']
      },
      {
        title: 'Exports',
        routerLink: '/exports',
        icon: 'exports',
        layouts: ['main']
      },
      {
        title: 'Settings',
        routerLink: '/settings/account',
        icon: 'settings',
        layouts: ['main'],
        section: 'bottom'
      },
      {
        title: 'Billing',
        routerLink: '/billing',
        icon: 'billing',
        layouts: ['main'],
        section: 'bottom'
      },

      // ----- Settings layout (same order) -----
      {
        title: 'Dashboard',
        routerLink: '/dashboard',
        icon: 'dashboard',
        layouts: ['settings']
      },
      {
        title: 'My Reports',
        routerLink: '/reports',
        icon: 'reports',
        layouts: ['settings']
      },
      {
        title: 'ICP Management',
        routerLink: '/icp',
        icon: 'icp',
        layouts: ['settings']
      },
      {
        title: 'Workspaces',
        routerLink: '/workspaces',
        icon: 'workspaces',
        layouts: ['settings']
      },
      {
        title: 'Prospecting',
        routerLink: '/advanced-search',
        icon: 'search',
        layouts: ['settings']
      },
      {
        title: 'Leads',
        routerLink: '/leads',
        icon: 'leads',
        layouts: ['settings']
      },
      {
        title: 'CRM',
        routerLink: '/crm',
        icon: 'crm',
        layouts: ['settings']
      },
      {
        title: 'Exports',
        routerLink: '/exports',
        icon: 'exports',
        layouts: ['settings']
      },
      {
        title: 'Settings',
        routerLink: '/settings/account',
        icon: 'settings',
        layouts: ['settings'],
        section: 'bottom'
      },
      {
        title: 'Billing',
        routerLink: '/billing',
        icon: 'billing',
        layouts: ['settings'],
        section: 'bottom'
      },
    ];
  }

  /**
   * Get navigation items filtered by layout
   * @param layout - Layout name to filter by
   */
  getNavigationItemsByLayout(layout: string): NavigationItem[] {
    return this.getNavigationItems().filter(item => item.layouts.includes(layout));
  }

}
